export enum DataTypeIec61360 {
  BLOB = 'BLOB',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  FILE = 'FILE',
  HTML = 'HTML',
  INTEGERCOUNT = 'INTEGER_COUNT',
  INTEGERCURRENCY = 'INTEGER_CURRENCY',
  INTEGERMEASURE = 'INTEGER_MEASURE',
  IRDI = 'IRDI',
  IRI = 'IRI',
  RATIONAL = 'RATIONAL',
  RATIONALMEASURE = 'RATIONAL_MEASURE',
  REALCOUNT = 'REAL_COUNT',
  REALCURRENCY = 'REAL_CURRENCY',
  REALMEASURE = 'REAL_MEASURE',
  STRING = 'STRING',
  STRINGTRANSLATABLE = 'STRING_TRANSLATABLE',
  TIME = 'TIME',
  TIMESTAMP = 'TIMESTAMP',
}
